import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KeyMenuComponent } from './key-menu.component';

@NgModule({
  declarations: [KeyMenuComponent], 
  imports: [ CommonModule  ],
  exports: [KeyMenuComponent ]
})
export class KeyMenuModule { }
 